module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "preface04"
    }
  }, [_vm._v("USDA Plant Hardiness Zone Map")])]), _c('a', {
    attrs: {
      "id": "preface04"
    }
  }), _c('div', {
    staticStyle: {
      "height": "450px"
    }
  }, [_c('a', {
    attrs: {
      "id": "preface04"
    }
  }), _c('p', {
    staticClass: "imagen"
  }, [_c('a', {
    attrs: {
      "id": "preface04"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxviii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/fxxviii-01a.jpg"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xxix"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xxix"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xxix"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xxix"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "550px"
    }
  }, [_c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/fxxviii-01b.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40433196","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preface04.vue
// module id = 69
// module chunks = 0